import { Container, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { RepositorySettingsSection } from "../features/repositorySettings/RepositorySettingsSection";

// Страница «Настройки → Настройки репозитория». Тонкий контейнер над
// секцией per-(org, repo) настроек — как `BranchNameTemplatePage`.
export function RepositorySettingsPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <Container py="xl">
      <Stack gap="xl">
        <Title order={1}>{t("repositorySettings.pageTitle")}</Title>
        <RepositorySettingsSection />
      </Stack>
    </Container>
  );
}
